{
	"preparingSample": "Preparing sample project ({{percent}}%)",
	"unavailable": "Sample project unavailable"
}
